// src/firebase.js
import { initializeApp } from "firebase/app";
import { getAuth } from "firebase/auth";
import { getFirestore } from "firebase/firestore";
import { getStorage } from "firebase/storage";
import { getFunctions } from 'firebase/functions';

// Importa as duas configurações
import { firebaseConfig as prodConfig } from './firebaseConfig.prod';
import { firebaseConfig as homologConfig } from './firebaseConfig.homolog';

// CORREÇÃO: Verifica se o domínio CONTÉM o endereço de produção, ignorando o www.
const hostname = window.location.hostname;
const isProduction = hostname === 'parcerias.mbigucci.com.br' || hostname === 'www.parcerias.mbigucci.com.br';

const config = isProduction ? prodConfig : homologConfig;

// Define a região (certifique-se de que ambos os projetos usem a mesma região para as functions)
const region = 'southamerica-east1';

const app = initializeApp(config);

export const auth = getAuth(app);
export const db = getFirestore(app);
export const storage = getStorage(app);
export const functions = getFunctions(app, region);